import gql from 'graphql-tag'

export const GET_DASHBOARD_DATA = gql`
  query coordinatorStats($waveId: String, $labId: String, $accountIds: [String]) {
    coordinator(accountIds: $accountIds) {
      stats(waveId: $waveId, labId: $labId) {
        learners {
          total
          active
        }
        stories {
          total
          highlights(count: 4) {
            id
            name
            resourceType
            thumbnailLocation
            resourceUri
            dateCreated
            tags {
              name
              id
            }
            user {
              id
              userName
              firstName
              lastName
              waves {
                id
                name
              }
            }
          }
        }
        tags {
          top(count: 6) {
            id
            name
            usageCount
          }
        }
      }
    }
  }
`
